var map = {
	".": "ZM3m",
	"./": "ZM3m",
	"./2023-09-12": "Sd/4",
	"./2023-09-12.json": "Sd/4",
	"./index": "ZM3m",
	"./index.js": "ZM3m"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xY+c";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/q&a ^.*$
// module id = xY+c
// module chunks = 3